module.exports = __webpack_public_path__ + "static/media/8.b36c5cb7.jpg";